// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"e5c8ab64","352":"ad067f7a","551":"f1b6cb32","633":"ef5a2d3d"}[chunkId] + ".chunk.css";
};